import styled from 'styled-components';

export const PageWrap = styled.div`
	>div{
		position: relative;
	}
	& .bgOverlay {
		background-image: linear-gradient(to left,rgba(0,0,0,0.5) 1%,#0b1a2f 98%) !important;
	}
`;

export const BorderWrap = styled.div`
	border-radius: 18px;
	background: #F76162;
	margin-bottom: 15px;
	width: 52px;
	height: 10px;
	display: inline-block;
`;
